// import external dependencies

// if using Sage's DOM router:
// import CustomEventPolyfill from 'custom-event-polyfill'; // eslint-disable-line no-unused-vars

import 'jquery';
import 'bootstrap';

import animations from './flexible-content/animations';
import gravityForms from './base/gravityForms';
import headroom from './base/headroom';
import objectFit from './base/objectFit';
import responsivePics from './base/responsivePics';
import { debounce } from 'throttle-debounce';

// layouts
import anchors from './flexible-content/anchors';
import applications from './flexible-content/applications';
import cardsColored from './flexible-content/cardsColored';
import contactForms from './flexible-content/contactForms';
import iconGrid from './flexible-content/iconGrid';
import imageGrid from './flexible-content/imageGrid';
import imageSlider from './flexible-content/imageSlider';
import postSlider from './flexible-content/postSlider';
import postThumbnailSlider from './flexible-content/postThumbnailSlider';
import sectionNavigation from './flexible-content/sectionNavigation';
import testimonials from './flexible-content/testimonials';
import textWithMedia from './flexible-content/textWithMedia';

// console.log(window.myConfig);

jQuery(document).ready(() => {
  animations();
  gravityForms();
  headroom();
  objectFit();

  // layouts
  anchors();
  applications();
  cardsColored();
  contactForms();
  iconGrid();
  imageGrid();
  imageSlider();
  postSlider();
  postThumbnailSlider();
  sectionNavigation();
  testimonials();
  textWithMedia();

  var navbarExpandBreakpoint = 1130; // $navbar-expand-breakpoint
  var $banner = $('.banner');
  var $nav = $('#mainNav');
  var $hamburger = $banner.find('.hamburger');

  $nav.on('hide.bs.collapse', function () {
    $banner.removeClass('open');
    $hamburger.removeClass('is-active');
  });

  $nav.on('show.bs.collapse', function () {
    $banner.addClass('open');
    $hamburger.addClass('is-active');
  });

  $('.navbar-nav-close').on('click', function(e) {
    e.preventDefault();
    $nav.collapse('hide');
  });

  $(window).on('resize', debounce(100, function() {
    if($(window).width() > navbarExpandBreakpoint) {
      $banner.removeClass('open');
      $nav.collapse('hide');
    }
  }));

  var $btn = $('.footer-link-fixed');
  $(window).on('scroll', function() { // should use debounce or IntersectionObserver instead.
    if($(this).scrollTop() > 50) {
      $btn.addClass('visible');
    }
    else {
      $btn.removeClass('visible');
    }
  });

  if(window.myConfig && window.myConfig.linkReplacements && window.myConfig.language !== 'en') {
    var $links = $('a');
    $.each(window.myConfig.linkReplacements, function(index, obj) {
      $links.each(function() {
        var $link = $(this);

        if($link.attr('href') === obj.link_en) {
          if(window.myConfig.language === 'es') {
            if(obj.link_es !== '') {
              $link.attr('href', obj.link_es)
            }
          }
          else if(window.myConfig.language === 'zh') {
            if(obj.link_zh !== '') {
              $link.attr('href', obj.link_zh)
            }
          }
          else if(window.myConfig.language === 'ja') {
            if(obj.link_ja !== '') {
              $link.attr('href', obj.link_ja)
            }
          }
          else if(window.myConfig.language === 'pt') {
            if(obj.link_pt !== '') {
              $link.attr('href', obj.link_pt)
            }
          }
          else if(window.myConfig.language === 'ko') {
            if(obj.link_ko !== '') {
              $link.attr('href', obj.link_ko)
            }
          }
        }
      });
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/main.js